import { ShoppingBag, Star, Truck } from 'lucide-react';
import { Button } from '../ui/button';

export const ProductCard = ({ product, index = 0 }) => {
  const {
    name,
    description,
    price,
    originalPrice,
    image,
    category,
    affiliateLink = '#',
    badge,
    rating = 4.8,
    reviewCount = 24,
  } = product;

  const handleClick = () => {
    if (affiliateLink && affiliateLink !== '#') {
      window.open(affiliateLink, '_blank', 'noopener,noreferrer');
    }
  };

  const isRealProduct = affiliateLink && affiliateLink !== '#';

  return (
    <div 
      className="product-card group bg-white rounded-2xl overflow-hidden shadow-soft hover:shadow-soft-hover animate-slide-up"
      style={{ animationDelay: `${index * 0.1}s` }}
      data-testid={`product-card-${product.id}`}
    >
      {/* Image */}
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F5F5F0]">
        <img src={image} alt={name} className="product-image w-full h-full object-cover" loading="lazy" />
        {badge && (
          <span className="absolute top-3 left-3 px-3 py-1 bg-red-500 rounded-full text-xs font-bold text-white">
            {badge}
          </span>
        )}
        {category && (
          <span className="absolute top-3 right-3 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-[#4A5D4F]">
            {category}
          </span>
        )}
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-1.5 line-clamp-2">{name}</h3>

        {/* Rating */}
        <div className="flex items-center gap-1.5 mb-2">
          <div className="flex">
            {[...Array(5)].map((_, i) => <Star key={i} className={`w-3 h-3 ${i < Math.floor(rating) ? 'fill-amber-400 text-amber-400' : 'text-gray-200'}`} />)}
          </div>
          <span className="text-xs text-[#6B7280]">{rating} ({reviewCount})</span>
        </div>

        <p className="text-[#6B7280] text-sm leading-relaxed mb-4 line-clamp-2">{description}</p>

        {/* Price */}
        <div className="flex items-center gap-2 mb-4">
          <span className="text-2xl font-medium text-[#2C332E]">{price}</span>
          {originalPrice && (
            <span className="text-sm text-[#9CA3AF] line-through">{originalPrice}</span>
          )}
          <span className="text-[10px] text-[#9CA3AF] ml-auto">inkl. MwSt.</span>
        </div>

        {/* Shipping */}
        <div className="flex items-center gap-1.5 text-xs text-[#4A5D4F] mb-4">
          <Truck className="w-3.5 h-3.5" />
          <span>Lieferung in 2-4 Werktagen</span>
        </div>

        {/* CTA */}
        <Button
          className={`w-full rounded-full py-6 font-medium transition-all duration-300 hover:shadow-lg ${
            isRealProduct 
              ? 'bg-[#4A5D4F] hover:bg-[#3A493E] text-white' 
              : 'bg-[#4A5D4F] hover:bg-[#3A493E] text-white'
          }`}
          data-testid={`product-cta-${product.id}`}
          onClick={handleClick}
        >
          <ShoppingBag className="w-4 h-4 mr-2" />
          Jetzt kaufen
        </Button>
      </div>
    </div>
  );
};
